import * as CubiqTS from "shared/cubiq-model-multi-asset";

import { DateAdapter } from "../DateAdapter";

// String types that are sortable as an Int32 in C++ module
export class SuspensionAdapter extends DateAdapter {
  constructor() {
    super();
    this.localeString = "HH:mm:ss";
  }

  getDate(order: any, columnProperty: string): CubiqTS.Moment {
    let suspensionDetails: CubiqTS.SuspensionDetailsImpl = order.suspensionDetails;
    if (suspensionDetails) {
      return suspensionDetails[columnProperty];
    }
    return null;
  }
}
